import React, { useState } from "react";
import { useAppStore } from "../../core/store/store";
import { MdBuild } from "react-icons/md";

export const DesktopIcon = ({ item, onOpen, prod }: any) => {
  const [hover, setHover] = useState(false);
  const theme = useAppStore((s) => s.ui.theme);
  const isDark = theme === "dark";

  const Icon = item.icon;

  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onDoubleClick={() => onOpen(item)}
      style={{
        width: 84,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 8,
        cursor: "default",
        userSelect: "none",
        transform: hover ? "scale(1.08)" : "scale(1)",
        transition: "transform 200ms cubic-bezier(.2,.8,.2,1)",
        opacity: hover ? 1 : 0.94,
        position: "relative",
      }}
    >
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: 16,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: isDark
            ? hover
              ? "linear-gradient(180deg, rgba(255,255,255,0.22), rgba(255,255,255,0.08))"
              : "linear-gradient(180deg, rgba(255,255,255,0.14), rgba(255,255,255,0.04))"
            : hover
            ? "linear-gradient(180deg, rgba(0,0,0,0.06), rgba(0,0,0,0.02))"
            : "linear-gradient(180deg, rgba(0,0,0,0.04), rgba(0,0,0,0.01))",
          backdropFilter: "blur(14px) saturate(130%)",
          WebkitBackdropFilter: "blur(14px) saturate(130%)",
          border: isDark
            ? hover
              ? "1px solid rgba(255,255,255,0.28)"
              : "1px solid rgba(255,255,255,0.18)"
            : hover
            ? "1px solid rgba(0,0,0,0.12)"
            : "1px solid rgba(0,0,0,0.08)",
          boxShadow: isDark
            ? hover
              ? `
                inset 0 1px 0 rgba(255,255,255,.35),
                0 16px 30px rgba(0,0,0,.45)
              `
              : `
                inset 0 1px 0 rgba(255,255,255,.25),
                0 10px 18px rgba(0,0,0,.35)
              `
            : hover
            ? `
                inset 0 1px 0 rgba(255,255,255,.9),
                0 6px 12px rgba(0,0,0,.12)
              `
            : `
                inset 0 1px 0 rgba(255,255,255,.85),
                0 4px 8px rgba(0,0,0,.08)
              `,
          transition: "all 200ms cubic-bezier(.2,.8,.2,1)",
          position: "relative",
        }}
      >
        <Icon
          size={26}
          style={{
            color: item.color || (isDark ? "#fff" : "#111"),
            transition: "color 180ms ease",
          }}
        />

        {!prod && (
          <div
            style={{
              position: "absolute",
              right: -4,
              bottom: -4,
              width: 16,
              height: 16,
              borderRadius: "50%",
              background: isDark ? "#f59e0b" : "#fbbf24",
              boxShadow: isDark
                ? "0 2px 6px rgba(0,0,0,.6)"
                : "0 2px 6px rgba(0,0,0,.25)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <MdBuild size={10} color="#111" />
          </div>
        )}
      </div>

      <div
        style={{
          fontSize: 11,
          fontWeight: 500,
          textAlign: "center",
          opacity: hover ? 1 : 0.8,
          color: isDark ? "#fff" : "#111",
          textShadow: isDark
            ? "0 2px 6px rgba(0,0,0,.6)"
            : "0 1px 1px rgba(255,255,255,.9)",
          lineHeight: "1.2",
          marginTop: 2
        }}
      >
        {item.label}
      </div>
    </div>
  );
};
